import { useCallback, useState } from 'react';
export var useOpenState = function (_a) {
    var resetHighlight = _a.resetHighlight, onOpen = _a.onOpen, onClose = _a.onClose;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var openDropdown = useCallback(function () {
        if (!isOpen) {
            setIsOpen(true);
            onOpen && onOpen();
        }
    }, [isOpen, setIsOpen]);
    var closeDropdown = useCallback(function () {
        if (isOpen) {
            resetHighlight();
            setIsOpen(false);
            onClose && onClose();
        }
    }, [isOpen, setIsOpen, resetHighlight]);
    var toggleDropdown = useCallback(function () {
        isOpen ? closeDropdown() : openDropdown();
    }, [isOpen, closeDropdown, openDropdown]);
    return { isOpen: isOpen, openDropdown: openDropdown, closeDropdown: closeDropdown, toggleDropdown: toggleDropdown };
};
//# sourceMappingURL=use-open-state.js.map